import React, { useEffect, useState } from 'react';
import Header from '../../components/header/Header';
import Footer from '../../components/footer/Footer';
import ChangelogFeed from '../../components/changelog/ChangelogFeed';
import RegisterModal from '../landing/components/RegisterModal/RegisterModal';
import logoFull from '../../assets/images/logo-full.png';
import { trackCtaClick } from '../../utils/analytics';
import usePageMeta from './usePageMeta';
import styles from './PublicChangelog.module.css';

const PAGE_TITLE = 'Novidades da Gabriela';
const PAGE_DESCRIPTION = 'Veja o que mudou na Gabriela semana a semana: novidades, melhorias e correções da Gabriela, para organizar a sua rotina.';

// Na página pública o selo de plano é só informação, sem atalho e sem "Ver na tela"
const publicCardProps = (entry) => ({ showPlan: Boolean(entry.plan) });

/**
 * /novidades: a mesma lista da tela logada, aberta no site, com o visual da landing.
 */
const PublicChangelogPage = () => {
  const [registerOpen, setRegisterOpen] = useState(false);
  usePageMeta(`${PAGE_TITLE} | Gabriela`, PAGE_DESCRIPTION);

  useEffect(() => {
    if (!window.location.hash) window.scrollTo(0, 0);
  }, []);

  // O mesmo formulário de cadastro da landing, aberto aqui mesmo
  const startTrial = () => {
    trackCtaClick({ placement: 'changelog_page' });
    setRegisterOpen(true);
  };

  return (
    <div className={styles.page}>
      <Header logoSrc={logoFull} showLoginButton />

      <section className={styles.hero}>
        <div className={styles.container}>
          <span className={styles.eyebrow}>Novidades</span>
          <h1 className={styles.heroTitle}>A Gabriela evolui toda semana</h1>
          <p className={styles.heroSubtitle}>
            Novas funcionalidades, melhorias e correções para deixar a sua rotina mais leve.
          </p>
          <button type="button" className={styles.ctaButton} onClick={startTrial}>
            Teste grátis
          </button>
        </div>
      </section>

      <main className={`${styles.container} ${styles.content}`}>
        <ChangelogFeed cardProps={publicCardProps} />
      </main>

      <section className={styles.cta}>
        <div className={styles.container}>
          <h2 className={styles.ctaTitle}>Quer ver tudo isso funcionando na sua rotina?</h2>
          <p className={styles.ctaSubtitle}>Teste a Gabriela por 30 dias, sem cartão de crédito.</p>
          <button type="button" className={styles.ctaButtonLight} onClick={startTrial}>
            Teste grátis
          </button>
        </div>
      </section>

      <Footer />
      <RegisterModal isOpen={registerOpen} onClose={() => setRegisterOpen(false)} />
    </div>
  );
};

export default PublicChangelogPage;
